// extracted by mini-css-extract-plugin
export default {"link":"navlinks_link__oGkL2","active":"navlinks_active__db7iU"};